import React, { ReactElement } from 'react';
import { Card } from 'antd';

import { Puppy } from 'types';
import { CardGridLinkStyled, CardGridStyled } from './Card.styles';
import { CardInformation } from './CardInformation';
import moment from 'moment';
import date from 'utilities/dates/date';

type Props = {
  puppy: Puppy;
  className?: string;
};

export const PuppyCard = ({ puppy, className }: Props): ReactElement => {
  const puppyName: string = puppy.breederName
    ? `${puppy.breederName} (${puppy.name})`
    : puppy.name;

  return (
    <Card className={className}>
      <CardGridStyled>
        <CardInformation
          label="Puppy Name"
          value={puppyName}
          title={puppyName}
          ellipsis={true}
        />
        <CardInformation label="Gender" value={puppy.gender ?? ''} />
        <CardInformation label="Breed" value={puppy.breed} />
        <CardInformation label="Age" value={moment(puppy.dateOfBirth).fromNow(true)} />
        <CardInformation label="Microchip" value={puppy.microchipRfid} />
      </CardGridStyled>
      <CardGridStyled>
        <CardInformation label="DOB" value={date.toUSLocale(puppy.dateOfBirth)} />
        <CardInformation
          label="Date sold"
          value={puppy.soldDate ? date.toUSLocale(puppy.soldDate) : ''}
        />
        <CardInformation
          label="Date available"
          value={date.toUSLocale(puppy.dateAvailable)}
        />
        <CardInformation label="Puppy weight" value={puppy.weightRange} />
        <CardInformation
          label="Weight last updated"
          value={date.toUSLocale(puppy.lastWeighedAt)}
        />
      </CardGridStyled>
      <CardGridLinkStyled>
        <a
          href={`https://www.buypuppiesdirect.com/leadtracker/puppy/mini-edit/?id=${puppy.id}`}
          target="_blank"
          rel="noreferrer"
        >
          Open in LeadTracker
        </a>
      </CardGridLinkStyled>
    </Card>
  );
};
